<template>

    <loading :showLoading="isLoading"></loading>

    <div v-if="intakes && intakes.length > 0" class="">
      <ul class="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        <button @click="addIntake" type="button" id="create-ll-intake-form" class="dashboard-card aspect-square create-ll-intake-form rounded-[8px] overflow-hidden flex items-center justify-center p-5 md:p-8 text-center border group border-brand-indigo bg-brand-light-purple hover:bg-brand-indigo" :style="{ opacity: hasLoaded ? 1 : 0 }">
          <div>
            <div class="mx-auto rounded-full size-11 mb-[10px] flex items-center justify-center bg-brand-indigo group-hover:bg-white">
              <svg class='text-white size-5 group-hover:text-brand-indigo icon icon-plus' aria-hidden='true'><use xlink:href='#icon-plus'></use></svg>
            </div>
            <p class="font-semibold paragraph-large text-brand-indigo group-hover:text-white">
              Create New Intake Form
            </p>
          </div>
        </button>
        <li v-for="(intake, index) in intakes" :key="intake.hash" :index="index" class="dashboard-card" :style="{ opacity: hasLoaded ? 1 : 0 }">
          <div class="form-card relative rounded-[8px] aspect-square flex items-center justify-center px-8 py-5 text-center border border-brand-light-gray bg-white">
            <div @click="openDuplicatePopup(intake.postId)" :class="'copy-button'+index" class="cursor-pointer group z-[90]">
              <svg class='absolute size-5 group-hover:text-brand-indigo top-3 left-3 text-brand-light-gray icon icon-copy'><use xlink:href='#icon-copy'></use></svg>
            </div>
            <template v-if="!templateId.includes(intake.postId)">
              <div @click="openPopup(intake.postId)" :class="'copy-button'+index" class="cursor-pointer group z-[90]">
                <svg class='absolute size-5 group-hover:text-brand-indigo top-3 right-3 text-brand-light-gray icon icon-bin'><use xlink:href='#icon-bin'></use></svg>
              </div>
            </template>
            <div>
              <div class="relative mx-auto mb-3 overflow-hidden border rounded-full aspect-square size-16 border-brand-light-gray">
                <template v-if="intake?.intakeForm?.content?.imageUrl">
                  <img :src="intake.intakeForm.content.imageUrl" :alt="intake.name" class="absolute inset-0 object-cover rounded-full size-full">
                </template>
              </div>
              <p class="mb-3 font-semibold text-center paragraph-large text-brand-wicked">
                {{ intake?.intakeForm?.content?.title }}
              </p>
              <div class="flex items-center justify-center" v-if="intake.status !== 'publish'">
                <a :href="'/intake/style/'+intake.hash" class="font-semibold text-center underline text-brand-indigo paragraph-small">
                  Continue Editing
                </a>
              </div>
              <div class="flex items-center justify-center" v-else>
                <a :href="'/form/'+intake.hash" target="_blank" class="mr-3 font-semibold text-center underline text-brand-indigo paragraph-small">
                  View Form
                </a>
                <template v-if="!templateId.includes(intake.postId)">
                  <a :href="'/intake/style/'+intake.hash" class="font-semibold text-center underline text-brand-indigo paragraph-small" v-if="intake.status !== 'publish'">
                    Edit Form
                  </a>
                  <a :href="'/intake/style/'+intake.hash" class="font-semibold text-center underline text-brand-indigo paragraph-small" v-if="intake.status === 'publish'">
                    Edit Form
                  </a>
                </template>

              </div>
              <div class="mt-2">
                <button
                  type="button"
                  @click="copyViewFormLink(intake.hash, index)"
                  class="size-5 group-hover:text-brand-indigo text-brand-light-gray icon"
                  title="Copy link"
                >
                  <svg class='icon icon-share'><use xlink:href='#icon-share'></use></svg>
                </button>
                <span v-if="copiedIndex === index" class="ml-2 text-xs text-brand-indigo">Copied!</span>
                <p class="absolute text-center -translate-x-1/2 bottom-4 left-1/2 text-brand-medium-gray paragraph-xsmall">
                  {{ intake.createdAt }}
                </p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div v-if="intakes.length > 0" class="flex items-center justify-center w-full gap-3 mt-8 md:gap-6 md:mt-10">
      <button @click="prevPage" :disabled="currentPage === 1" class="flex items-center gap-2 px-4 py-2 transition duration-300 rounded hover:text-brand-indigo text-brand-medium-gray disabled:opacity-50" v-if="currentPage > 1">
        Previous
        <svg class='icon icon-chevron-left text-brand-medium-gray'>
          <use xlink:href='#icon-chevron-left'></use>
        </svg>
      </button>
      <span class="font-medium text-brand-wicked paragraph-default">Page {{ currentPage }} of {{ totalPages }}</span>
      <button @click="nextPage" :disabled="currentPage === totalPages" class="flex items-center gap-2 px-4 py-2 transition duration-300 rounded hover:text-brand-indigo text-brand-medium-gray disabled:opacity-50" v-if="currentPage !== totalPages">
        <span class="sr-only">Next</span>
        <svg class='icon icon-chevron-right text-brand-medium-gray'>
          <use xlink:href='#icon-chevron-right'></use>
        </svg>
      </button>
    </div>

    <div v-if="hasLoaded && intakes.length <= 0">
      <p class="sr-only">{{ message }}</p>
      <div class="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        <button @click="addIntake" type="button" id="create-ll-intake-form" class="dashboard-card aspect-square create-ll-intake-form rounded-[8px] overflow-hidden flex items-center justify-center p-5 md:p-8 text-center border group border-brand-indigo bg-brand-light-purple hover:bg-brand-indigo">
        <div>
          <div class="mx-auto rounded-full size-11 mb-[10px] flex items-center justify-center bg-brand-indigo group-hover:bg-white">
            <svg class='text-white size-5 group-hover:text-brand-indigo icon icon-plus' aria-hidden='true'><use xlink:href='#icon-plus'></use></svg>
          </div>
          <p class="font-semibold paragraph-large text-brand-indigo group-hover:text-white">
            Create New Intake Form
          </p>
        </div>
      </button>
      </div>
    </div>

    <div v-if="showDeleteFormConfirmationPopup" @click="closePopup" class="fixed -translate-x-1/2 -translate-y-1/2 z-[90] size-full bg-brand-scrim top-1/2 left-1/2"></div>
    <div v-if="showDeleteFormConfirmationPopup" class="fixed w-[432px] max-w-[90vw] z-[91] flex flex-col rounded-[8px] p-6 md:py-10 md:px-8 mx-auto bg-white top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2">
      <button type="button" class="mfp-close top-3 right-3 size-10" @click="closePopup">
        <svg class="rotate-45 pointer-events-none size-6 icon icon-plus text-brand-medium-gray" aria-hidden="true"><use xlink:href="#icon-plus"></use></svg>
      </button>
      <p class="hdg-5 text-brand-wicked">
        Are you sure you want to delete this intake form?
      </p>

      <div class="flex items-center justify-end gap-4 mt-8 form">
        <input
        :class="{ 'border border-form-error' : errorMessage, '' : !errorMessage }"
        class="mt-0 form-submit btn-secondary" type="submit" name="delete_form" value="Cancel" @click="closePopup">
        <input
          :class="{ 'border border-form-error' : errorMessage, '' : !errorMessage }"
          class="mt-0 form-submit btn-primary" type="submit" name="delete_form" value="Delete" @click="deleteForm">

        <div v-if="errorMessage" class="mt-2 text-form-error">{{ errorMessage }}</div>
      </div>
    </div>

    <div v-if="showDuplicateFormConfirmationPopup" @click="closeDuplicatePopup" class="fixed -translate-x-1/2 -translate-y-1/2 z-[90] size-full bg-brand-scrim top-1/2 left-1/2"></div>
    <div v-if="showDuplicateFormConfirmationPopup" class="fixed w-[432px] max-w-[90vw] z-[91] flex flex-col rounded-[8px] p-6 md:py-10 md:px-8 mx-auto bg-white top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2">
      <button type="button" class="mfp-close top-3 right-3 size-10" @click="closeDuplicatePopup">
        <svg class="rotate-45 pointer-events-none size-6 icon icon-plus text-brand-medium-gray" aria-hidden="true"><use xlink:href="#icon-plus"></use></svg>
      </button>
      <p class="hdg-5 text-brand-wicked">
        Are you sure you want to duplicate this intake form?
      </p>

      <div class="flex items-center justify-end gap-4 mt-8 form">
        <input
        :class="{ 'border border-form-error' : errorMessage, '' : !errorMessage }"
        class="mt-0 form-submit btn-secondary" type="submit" name="duplicate_form" value="Cancel" @click="closeDuplicatePopup">
        <input
          :class="{ 'border border-form-error' : errorMessage, '' : !errorMessage }"
          class="mt-0 form-submit btn-primary" type="submit" name="duplicate_form" value="Duplicate" @click="duplicateForm">

        <div v-if="errorMessage" class="mt-2 text-form-error">{{ errorMessage }}</div>
      </div>
    </div>

</template>

<script setup>
const axios = require('axios');
import { ref, onMounted, nextTick } from 'vue';
import { gsap } from 'gsap';
const props = defineProps({
  homeUrl: String,
  templateId: Array,
});

const intakes = ref([]);
const isRunning = ref(false);
const isLoading = ref(true);
const hasLoaded = ref(false);
const message = ref('');
const currentPage = ref(1);
const totalPages = ref(1);
const perPage = 11;
const shareLinkText = ref('');
const lshareUrl = ref('');
const showDeleteFormConfirmationPopup = ref(false);
const showDuplicateFormConfirmationPopup = ref(false);
const errorMessage = ref(false);
const intakeId = ref(0);

const openPopup = (id) => {
  intakeId.value = id;
  showDeleteFormConfirmationPopup.value = true;
};
const openDuplicatePopup = (id) => {
  intakeId.value = id;
  showDuplicateFormConfirmationPopup.value = true;
};
const closePopup = () => {
  intakeId.value = 0;
  showDeleteFormConfirmationPopup.value = false;
};
const closeDuplicatePopup = () => {
  intakeId.value = 0;
  showDuplicateFormConfirmationPopup.value = false;
};

const deleteForm = async (postId) => {
  if (!isRunning.value && intakeId.value) {
    try {
      const { data } = await axios.post(
        `${siteInfo.wpApiSettings.ll}intake/delete`,
        {
          postId: intakeId.value,
        },
        {
          headers: {
            'X-WP-Nonce': siteInfo.wpApiSettings.nonce,
            'X-Requested-With': 'XMLHttpRequest'
          },
        }
      );
      window.location.href = "/";
    } catch (error) {
      console.error('Error publishing intake form:', error);
      return false;
    }
  }
}



const duplicateForm = async (postId) => {
  if (!isRunning.value && intakeId.value) {
    try {
      const { data } = await axios.post(
        `${siteInfo.wpApiSettings.ll}intakes/duplicate`,
        {
          postId: intakeId.value,
        },
        {
          headers: {
            'X-WP-Nonce': siteInfo.wpApiSettings.nonce,
            'X-Requested-With': 'XMLHttpRequest'
          },
        }
      );
      window.location.href = "/";
    } catch (error) {
      console.error('Error publishing intake form:', error);
      return false;
    }
  }
}

onMounted(() => {
  fetchIntakes();
});

const copy = (index, hash) => {
  $('.copy-button'+index).addClass('is-active');
  if(lshareUrl.length > 0) {
    lshareUrl.value = '';
  }
  lshareUrl.value = props.homeUrl + '/form/' + hash;
  setTimeout(() => {
    $('#intake-form'+index).select();
    document.execCommand('copy');
  }, 250);

  setTimeout(() => {
    $('.copy-button'+index).removeClass('is-active');
  }, 1500);
}

function fetchIntakes(page = 1) {
  if (!isRunning.value) {
    isRunning.value = true;
    axios({
      method: 'GET',
      url: `${siteInfo.wpApiSettings.ll}intakes/get`,
      headers: {
        'X-WP-Nonce': siteInfo.wpApiSettings.nonce,
        'X-Requested-With': 'XMLHttpRequest'
      },
      params: {
        page: page,
        per_page: perPage
      }
    })
      .then(async response => {
        isRunning.value = false;
        if(response.data.message) {
          message.value = response.data.message;
        }
        if(response.data.intakes) {
          intakes.value = response.data.intakes;
        }
        currentPage.value = page;
        if(response.data.pagination) {
          totalPages.value = response.data.pagination.total_pages;
        }

        // Animate cards in after DOM updates
        await nextTick();
        const cards = document.querySelectorAll('.dashboard-card');
        if (cards.length) {
          gsap.fromTo(cards,
            { opacity: 0, y: 24 },
            { opacity: 1, y: 0, duration: 0.4, stagger: 0.06, ease: 'power2.out' }
          );
        }
      })
      .catch(error => {
        console.error('Error:', error);
      })
      .finally(() => {
        isLoading.value = false;
        hasLoaded.value = true;
      });
  }
}

function addIntake() {
  if (!isRunning.value) {
    isRunning.value = true;
    axios({
      method: 'POST',
      url: `${siteInfo.wpApiSettings.ll}intakes/create`,
      headers: {
        'X-WP-Nonce': siteInfo.wpApiSettings.nonce,
        'X-Requested-With': 'XMLHttpRequest'
      },
    })
      .then(response => {
        isRunning.value = false;
        window.location.href = '/intake/style/' + response.data.intake_hash;
      })
      .catch(error => {
        console.error('Error:', error);
      })
      .finally(() => {

      });
  }
}

function nextPage() {
  if (currentPage.value < totalPages.value) {
    fetchIntakes(currentPage.value + 1);
  }
}

function prevPage() {
  if (currentPage.value > 1) {
    fetchIntakes(currentPage.value - 1);
  }
}
const copiedIndex = ref(null);
function copyViewFormLink(hash, index) {
  const url = `${props.homeUrl}/form/${hash}`;
  // Use the Clipboard API if available
  if (navigator.clipboard) {
    navigator.clipboard.writeText(url).then(() => {
      copiedIndex.value = index;
      setTimeout(() => {
        copiedIndex.value = null;
      }, 1500);
    });
  } else {
    // Fallback for older browsers
    const tempInput = document.createElement('input');
    tempInput.value = url;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);
    copiedIndex.value = index;
    setTimeout(() => {
      copiedIndex.value = null;
    }, 1500);
  }
}
</script>
